import React, {useMemo} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";

const mapStateToProps = ({initialData}, ownProps) => ({
    ...ownProps,
    paymentDetails: initialData.paymentDetails,
});

const StripeWrapper = (props) => {
    const stripePromise = useMemo(
        () => props.paymentDetails.stripePublicKey ? loadStripe(props.paymentDetails.stripePublicKey) : null,
        [props.paymentDetails.stripePublicKey]
    );

    const Component = props.component;
    return (
        <Elements stripe={stripePromise}>
            <Component {...props} />
        </Elements>
    );
};

export default withRouter(connect(mapStateToProps)(StripeWrapper));